import React from "react";

const NotFound = () => {
  return (
    <div className="flex justify-center items-center text-white text-2xl w-screen h-screen">
      NOT FOUND
    </div>
  );
};

export default NotFound;
